<template>
    <el-drawer title="订单详情" size="50%" :visible.sync="dialogVisible" direction="rtl" @close="dialogFormVisible">
      <div class="p-0-20"><Detail :order_id="order_id" :is_drawer="1"></Detail></div>
    </el-drawer>
</template>

<script>
import Detail from "../detail.vue";
export default {
  components: {
    Detail,
  },
  data() {
    return {
      loading: false,
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ["is_open", "order_id"],
  created() {
    //是否展示
    this.dialogVisible = this.is_open;
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog", { openDialog: false });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Detail.vue